// extracted by mini-css-extract-plugin
export var content = "InitialSignUpScreen-module__content___hZxjr";
export var create = "InitialSignUpScreen-module__create___UfRE5";
export var grid = "InitialSignUpScreen-module__grid___GSL9Y";
export var mdVisible = "InitialSignUpScreen-module__mdVisible___yHE5U";